/* eslint import/prefer-default-export: 0 */
import { ICON, RESOURCE_TYPE } from './CONSTANTS';

const preloadImages = images => images.forEach((imageUrl) => {
    const image = new Image();
    image.src = imageUrl;
});

const getDocumentIcon = (document) => {
    let iconUrl = ICON.LINK;

    if (document.icon) {
        iconUrl = document.icon;
    } else if (document.resource_type === RESOURCE_TYPE.TETTRA_PDF) {
        iconUrl = ICON.PDF_DOCUMENT;
    }

    return iconUrl;
};

export { preloadImages, getDocumentIcon };
